import React, { useCallback, useEffect, useState } from "react";
import { loginAction } from "../Services/Store/Actions/AuthActions";
import { showToast } from "../utils/helpers";
import { REACT_APP_GOOGLE_CLIENT_ID } from "../utils/env";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface GoogleLoginBtnType {
  onSuccess?: Function | null;
}

const GoogleLoginBtn: React.FC<GoogleLoginBtnType> = ({ onSuccess = null }) => {
  const dispatch = useDispatch();

  const [socialLoginLoader, setSocialLoginLoader] = useState<boolean>(false);

  const loginWithGoogle = useCallback((response: any) => {
    console.log("GoogleLogin :", response);

    if (response && response.credential) {
      setSocialLoginLoader(true);

      loginAction({ type: "google", idtoken: response.credential }, dispatch)
        .then((res) => {
          showToast("success", res.message);

          if (onSuccess) {
            onSuccess();
          }
        })
        .catch((err) => showToast("error", err.message))
        .finally(() => setSocialLoginLoader(false));
    } else {
      showToast("error", "Failed to login with Google. Please try again.");
    }
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (window.google) {
        window.google.accounts.id.initialize({
          client_id: REACT_APP_GOOGLE_CLIENT_ID,
          callback: loginWithGoogle,
        });

        window.google.accounts.id.renderButton(
          document.getElementById("googleSignInButton"),
          {
            theme: "outline",
            size: "large",
            width: "100%",
            text: "signin_with",
          }
        );
      }
    };

    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      {socialLoginLoader && <FontAwesomeIcon icon={faSpinner} spin />}

      {!socialLoginLoader && <div id="googleSignInButton"></div>}
    </>
  );
};

export default GoogleLoginBtn;
